
import Model from './Model'


export default class Discipline extends Model
{
    static Key = 'Discipline';

	static disciplinesById;

	static allDisciplineSkills() {
        let skills = TB.flatMap(this.cached(), 'skills');

        return TB.uniqBy(skills, 'id');
    }

    static matchedSkillsFor(skills, disciplineId) {

	    let userSkills = TB.keyBy(this.skillsFor(disciplineId), 'id');

	    return TB.filter(skills, skill => TB.isDefined(userSkills[skill.id]));
    }

    static skillsFor(disciplineId)
    {
        let skills = this.find(disciplineId)?.skills || []

        return TB.sortBy(skills, 'pivot.display_index');
    }

    static industriesFor(disciplineId)
    {
        return this.find(disciplineId)?.industries || []
    }


    static cached()
    {
        if (!this.Cached) {
            this.Cached = TB.keyBy(
                TB.flatMap(
                    [...laravel.discipline_categories],
                    'disciplines'
                ),
                'id'
            );
        }
        return this.Cached || [];
    }

    static find(disciplineId)
    {
        let disciplines = this.cached();

        let discipline = TB.find(disciplines, ['id', disciplineId]);

        if(!discipline) return false;


        return this.make({...discipline});
    }
}
